import React, { useState, useEffect } from "react";
import WeatherForecastDay from "./weatherForecastDay";
import "./weatherForecast.css";
import axios from "axios";

export default function WeatherForecast(props) {
  let [loaded, setLoad] = useState(false);
  let [forecast, setForecast] = useState(null);

  useEffect(() => {
    setLoad(false);
  }, [props.cities]);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoad(true);
  }

  if (loaded) {
    return (
      <div className="WeatherForecast">
        <div className="row">
          {forecast.map(function (dailyForecast, index) {
            if (index < 5) {
              return (
                <div className="col" key={index}>
                  <WeatherForecastDay data={dailyForecast} />
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    const apiKey = "260420cae416f4dteddo330fbd8c9c7b";
    const city = props.cities;
    const units = "metric";
    let url = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=${apiKey}&units=${units}`;
    axios.get(url).then(handleResponse);
    return "Loading...";
  }
}
